module.exports = __webpack_public_path__ + "img/twitter.07400a31.svg";